import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect } from "react";
import {
  Grid,
  Card,
  Typography,
  Box,
  Switch,
  Skeleton,
  Tabs,
  Tab,
  Tooltip as Muitooltip,
  IconButton,
} from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import axios from "axios";
import { useState } from "react";
import FadeLoader from "react-spinners/FadeLoader";
import InfoTooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { styled } from "@mui/material/styles";
import { tooltipClasses } from "@mui/material/Tooltip";
import { ResponsivePie } from "@nivo/pie";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Sector,
} from "recharts";
import SquareIcon from "@mui/icons-material/Square";
import Select from "react-select";
import ReactApexChart from "react-apexcharts";
import {
  SBox1,
  SBox2,
  SBox3,
  SBox4,
  SBox5,
  SGHeading,
  SGSubHeading,
  SGTitles,
  SGToggles,
  SGraphSubHeading,
  SGridBox,
  SHeading,
  SHeading1,
  SKPICount,
  SKPIHeading,
  SKPISubHeading1,
  SKPISubHeading2,
  SUnderlineBox,
  SVerticalBox,
} from "./Style";
import A1 from "../../assets/images/KPI/1.png";
import A2 from "../../assets/images/KPI/2.png";
import A3 from "../../assets/images/KPI/3.png";
import A4 from "../../assets/images/KPI/4.png";
import A5 from "../../assets/images/KPI/5.png";
import A6 from "../../assets/images/KPI/6.png";
import A7 from "../../assets/images/KPI/7.png";
import info from "../../assets/images/Group 1000004191.png";
// import A8 from "../../assets/images/KPI/A8.png";
import "./style.css";
// import { propTypes } from "react-bootstrap/esm/Image";
import PropTypes from "prop-types";

export const CustomTooltip = ({ payload, label, active }) => {
  console.log("custom payload:", payload);
  console.log("custom label:", label);
  console.log("custom active:", active);
  if (active) {
    return (
      <div className="custom-tooltip">
        {/* <p className="label">{`${payload[0].payload.name}`}</p> */}
        <p className="label">{`${payload[0]?.payload?.name}`}</p>
        <p
          style={{ color: `${payload[0]?.fill}` }}
        >{`Requirements Given : ${payload[0]?.payload?.requested}`}</p>
        <p style={{ color: `${payload[1]?.fill}` }}>{`Shared : ${payload[0]?.payload?.shared}`}</p>
        <p
          style={{ color: `${payload[2]?.fill}` }}
        >{`Engaged : ${payload[0]?.payload?.shortlisted}`}</p>
        {/* <p className="intro">{getIntroOfPage(label)}</p> */}
        {/* <p className="desc">Anything you want can be displayed here.</p> */}
      </div>
    );
  }

  return null;
};
const getIntroOfPage = (label) =>
  label === "Role 1"
    ? "custum 1"
    : label === "Role 2"
    ? "custom 2"
    : label === "Role 3"
    ? "custom 3"
    : label === "Role 4"
    ? "custom 4"
    : label === "Role 5"
    ? "custom 5"
    : label === "Role 6"
    ? "custom 6"
    : label === "Role 7"
    ? "custom 7"
    : label === "Role 8"
    ? "custom 8"
    : label === "Role 9"
    ? "custom 9"
    : label === "Role 10"
    ? "custom 10"
    : "custom 11";

const SuperAdminOverview = () => {
  const [toggle1, setToggle1] = useState(false);
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState(0);
  const [roleType, setRoleType] = useState("qualification");
  const [value1, setValue1] = useState(0);
  const [roleType1, setRoleType1] = useState("requested");
  const [roleOptions, setRoleOptions] = useState([
    // { label: "ALL", value: "" },
    // { label: "Role", value: "role" },
  ]);
  const [jobId, setJobId] = useState("");
  const [jobName, setJobName] = useState("");

  const [data, setData] = useState([]);

  const [data6, setData6] = useState([
    // {
    //   name: "Total Candidates",
    //   Candidates: 120000,
    //   percent: "100%",
    //   msg: "Reason for Leakage: Data Incorrect or Not on Whatsapp, Profile Not Matching",
    // },
    // {
    //   name: "Bot Successfully Engaged",
    //   Candidates: 100000,
    //   percent: "80%",
    //   msg: "Reason for Leakage: Need to connect manually, Interest low on their end",
    // },
    // {
    //   name: "Counsellor Engagement on",
    //   Candidates: 90000,
    //   percent: "70%",
    //   msg: "Reason for Leakage: Need to connect and guide them",
    // },
    // {
    //   name: "Interview process initiated",
    //   Candidates: 80000,
    //   percent: "65%",
    //   msg: "Reason for Leakage:  Need to connect and guide them",
    // },
    // {
    //   name: "Interview process on",
    //   Candidates: 70000,
    //   percent: "60%",
    //   msg: "Reason for Leakage:  Need to connect and guide them",
    // },
    // {
    //   name: "Final Selection on",
    //   Candidates: 60000,
    //   percent: "55%",
    //   msg: "Reason for Leakage:  Need to connect and guide them",
    // },
    // {
    //   name: "Post Selection stage",
    //   Candidates: 50000,
    //   percent: "50%",
    //   msg: "Reason for Leakage:  Need to connect and guide them",
    // },
  ]);

  const [data5, setData5] = useState([]);

  const [data4, setData4] = useState([
    // { name: "SSC", value: 400, color: "#F94144" },
    // { name: "HSC", value: 300, color: "#90BE6D" },
    // { name: "Diploma", value: 300, color: "#F9C74F" },
    // { name: "Graduation", value: 200, color: "#2D9CDB" },
    // { name: "Post Graduation", value: 400, color: "#F3722C" },
    // { name: "Certification Course", value: 300, color: "#F9C74F" },
  ]);

  const [data3, setData3] = useState([]);

  const [data1, setData1] = useState([]);

  const [KPIObj, setKPIObj] = useState({
    total_shared: 0,
    jobs_assigned: 0,
    cand_accross_job: 0,
    accepted: 0,
    declined: 0,
    requested: 0,
    in_pipeline: 0,
    placed: 0,
  });

  const [kpiArr, setKpiArr] = useState([
    {
      heading: "Total Candidates Shared",
      subheading: "Total Placed :",
      count1: 0,
      count2: 0,
      img: A1,
    },
    {
      heading: "Jobs Assigned",
      subheading: "Total Job Post :",
      count1: 0,
      count2: 0,
      img: A2,
    },
    {
      heading: "Candidates Accross Jobs",
      subheading: "Recently Added :",
      count1: 0,
      count2: 0,
      img: A1,
    },
    {
      heading: "Jobs Accepted",
      subheading: "Total Job Post :",
      count1: 0,
      count2: 0,
      img: A3,
    },
    {
      heading: "Jobs Rejected",
      subheading: "Upcoming Job Fair :",
      count1: 0,
      count2: 0,
      img: A4,
    },
    {
      heading: "Jobs Onhold",
      subheading: "Recently Added :",
      count1: 0,
      count2: 0,
      img: A5,
    },
    {
      heading: "Candidates In Pipeline",
      subheading: "Total Placed :",
      count1: 0,
      count2: 0,
      img: A6,
    },
    {
      heading: "Total Placed",
      subheading: "Total Job Post :",
      count1: 0,
      count2: 0,
      img: A7,
    },
  ]);

  const handleChange = (event, newValue) => {
    console.log("changes:", event);
    console.log("changes2:", newValue);
    setValue(newValue);
    setRoleType(
      newValue === 0
        ? "qualification"
        : newValue === 1
        ? "gender"
        : newValue === 2
        ? "age"
        : "qualification"
    );
  };
  const handleChange1 = (event, newValue) => {
    console.log("changes:", event);
    console.log("changes2:", newValue);
    setValue1(newValue);
    setRoleType1(newValue === 0 ? "requested" : newValue === 1 ? "accepted" : "requested");
  };

  /*
  const fetchJobPostKpi = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/superadmin/candidatesearch/jobpostkpi`)
      .then((res) => {
        console.log("all kpi", res.data);
        setJobPosted(res.data.Job_Count);
        console.log(jobPosted);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  */

  const stylesDD = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      fontSize: "14px",
      width: "200px",
    }),
    option: (base) => ({
      ...base,
      height: "100%",
      fontSize: "14px",
    }),
  };

  const option1 = [{ label: "All", value: "All" }];

  const option2 = [{ label: "Mar-Apr", value: "Mar-Apr" }];

  //Pyramid
  const Series = {
    series: [
      {
        name: data6.map((v, i) => v.msg),
        // name: "Steps",
        data: data6.map((v) => v.Candidates),
      },
    ],
  };

  //Pyramid
  const option3 = {
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false,
          tools: {
            download: false,
          },
        },
        fontFamily: "Inter",
        fontSize: "10px",
      },
      tooltip: {
        enabled: true,
        // width: "50%",
        // height: "70px",
        // style: {
        //   width: "100px",
        //   height: "150px",
        // },
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          {
            console.log("hover:", dataPointIndex);
          }
          return dataPointIndex !== 0
            ? "<div style={{margin:'4px'}}>" +
                "<ul>" +
                "<li>" +
                "<div >" +
                `Count : ${w.globals.series[0][dataPointIndex]}` +
                "</div>" +
                "</li>" +
                `${
                  // w.globals.seriesNames[0][dataPointIndex] !== "" &&
                  "<li>" +
                  "<div>" +
                  // series[seriesIndex][dataPointIndex] +

                  // dataPointIndex !== 0 &&
                  `${w.globals.seriesNames[0][dataPointIndex]}` +
                  "</div>" +
                  "</li>"
                }` +
                "</ul>" +
                "</div>"
            : "<div style={{margin:'8px',display:'flex',alignItems:'center'}}>" +
                "<ul>" +
                // "<li>" +
                // "<div >" +
                // `Count : ${w.globals.series[0][dataPointIndex]}` +
                // "</div>" +
                // "</li>" +
                `${
                  // w.globals.seriesNames[0][dataPointIndex] !== "" &&
                  "<li>" +
                  "<div>" +
                  // series[seriesIndex][dataPointIndex] +

                  // dataPointIndex !== 0 &&
                  `${w.globals.seriesNames[0][dataPointIndex]}` +
                  "</div>" +
                  "</li>"
                }` +
                "</ul>" +
                "</div>";
        },
        // fixed: {
        //   enabled: false,
        //   position: "topRight",
        //   offsetX: 0,
        //   offsetY: 0,
        // },
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          horizontal: true,
          distributed: true,
          barHeight: "80%",
          isFunnel: true,
        },
      },
      colors: ["#88ABAE", "#F94144", "#2D9CDB", "#F8961E", "#C69774", "#90BE6D", "#F3722C"],
      dataLabels: {
        enabled: true,
        formatter: function (val, opt) {
          return val;
        },
        dropShadow: {
          enabled: false,
        },
      },
      xaxis: {
        categories: data6.map((v) => v.name),
        percentage: data6.map((v) => v.percent),
      },
      legend: {
        show: false,
      },
    },
  };

  const COLORS = ["#F94144", "#90BE6D", "#F9C74F", "#2D9CDB", "#F3722C", "#F9C74F"];

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    console.log("percent:", percent);
    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
        style={{ fontFamily: "Inter", fontSize: "12px" }}
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  const renderCustomizedLabel1 = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
        style={{ fontFamily: "Inter", fontSize: "12px" }}
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  const FetchGraph3 = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/job_request_vs_shared`,
        {
          cp_id: sessionStorage.getItem("register_id"),
        }
      );

      const data = await res.data;
      setData1(
        data?.data?.map((v, i) => {
          return {
            name: v.name,
            role: `Role ${i + 1}`,
            shortlisted: v.shortlisted,
            requested: v.requested,
            shared: v.shared,
          };
        })
      );
    } catch (err) {
      console.log(err);
    }
  };

  const FetchGraph4 = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/top_job_role_requested`,
        {
          cp_id: sessionStorage.getItem("register_id"),
          type: value1,
        }
      );

      const data = await res.data;
      const sumtotal = data?.data?.map((v) => v.value).reduce((a, c) => a + c, 0);

      console.log(data, "cid");
      setData3(
        data?.data?.map((v) => {
          return {
            id: v.jobpost_name
              ? v.jobpost_name
                  ?.split(" ")
                  ?.map((v) => v?.charAt(0)?.toUpperCase() + v?.slice(1))
                  ?.join(" ")
              : "",
            label: v.jobpost_name
              ? v.jobpost_name
                  ?.split(" ")
                  ?.map((v) => v?.charAt(0)?.toUpperCase() + v?.slice(1))
                  ?.join(" ")
              : "",
            value: v.value,
            color: v?.color,
            percent: `${((v.value / sumtotal) * 100).toFixed(2)}%`,
          };
        })
      );
    } catch (err) {
      console.log(err);
    }
  };

  const FetchGraph6 = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/cp_request_shared_assigned`,
        {
          cp_id: sessionStorage.getItem("register_id"),
        }
      );

      const data = await res.data;
      console.log(data.data, "5695");
      setData5(
        data?.data?.map((v) => {
          return {
            name: v.name,
            count: v.count,
            fill:
              v?.name === "Candidates" ? "#F94144" : v?.name === "Placed" ? "#90BE6D" : "#2D9CDB",
          };
        })
      );
    } catch (err) {
      console.log(err);
    }
  };

  const FetchGraph1 = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/job_status`,
        {
          cp_id: sessionStorage.getItem("register_id"),
        }
      );

      const data = await res.data;
      console.log(data, "56911");
      setData(
        data?.data?.map((v) => {
          return {
            name: v.name === "Decline" ? "Declined" : v.name,
            count: v.count,
          };
        })
      );
    } catch (err) {
      console.log(err);
    }
  };
  const FetchGraph2 = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/mis/call/details`,
        {
          cp_id: sessionStorage.getItem("register_id"),
          jobid: jobId,
        }
      );

      const data = await res.data;
      console.log(
        "data6",
        data.data.filter((item, id) => item.Candidates !== 0)
      );
      setData6(data.data);
      // setData6(data.data.filter((item, id) => item.Candidates !== 0));
    } catch (err) {
      console.log(err);
    }
  };
  console.log("data7:", data6);
  const FetchGraph5 = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/mis/data/user`,
        {
          cp_id: sessionStorage.getItem("register_id"),
          type: roleType,
        }
      );

      const data = await res.data;
      const sumtotal = data?.data?.map((v) => v.percent).reduce((a, c) => a + c, 0);

      setData4(
        data?.data?.map((v, i) => {
          return {
            id: v.name
              ? v.name
                  ?.split(" ")
                  ?.map((v) => v?.charAt(0)?.toUpperCase() + v?.slice(1))
                  ?.join(" ")
              : "",
            // role: `Role ${i + 1}`,
            label: v.name
              ? v.name
                  ?.split(" ")
                  ?.map((v) => v?.charAt(0)?.toUpperCase() + v?.slice(1))
                  ?.join(" ")
              : "",
            value: v.count,
            // color: data3.map((el) => el.fill),
            color: v.color,
            percent: `${((v.percent / sumtotal) * 100).toFixed(2)}%`,
          };
        })
      );
    } catch (err) {
      console.log(err);
    }
  };
  const RoleOptionsFunc = async () => {
    await axios
      .post(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/jobidlist`, {
        cp_id: sessionStorage.getItem("register_id"),
      })
      .then((res) => setRoleOptions(res.data))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    FetchGraph1();
    // FetchGraph2();
    FetchGraph3();
    FetchGraph4();
    // FetchGraph5();
    FetchGraph6();
    OverallKPIFunc();
    RoleOptionsFunc();
  }, []);

  console.log(data4, "data4");

  const OverallKPIFunc = async () => {
    setLoading(true);
    await axios
      .post(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/mis/kpi`, {
        cp_id: sessionStorage.getItem("register_id"),
      })
      .then(
        (res) => (
          setLoading(false),
          setKpiArr([
            {
              heading: "Total Candidates Shared",
              subheading: "Total Placed :",
              count1: res.data?.data.total_shared,
              count2: 0,
              img: A1,
            },
            {
              heading: "Jobs Assigned",
              subheading: "Total Job Post :",
              count1: res.data?.data.jobs_assigned,
              count2: 0,
              img: A2,
            },
            {
              heading: "Candidates Across Jobs",
              subheading: "Recently Added :",
              count1: res.data?.data.cand_accross_job,
              count2: 0,
              img: A1,
            },
            {
              heading: "Jobs Accepted",
              subheading: "Total Job Post :",
              count1: res.data?.data.accepted,
              count2: 0,
              img: A3,
            },
            {
              heading: "Jobs Rejected",
              subheading: "Upcoming Job Fair :",
              count1: res.data?.data.declined,
              count2: 0,
              img: A4,
            },
            {
              heading: "Jobs Onhold",
              subheading: "Recently Added :",
              count1: res.data?.data.requested,
              count2: 0,
              img: A5,
            },
            {
              heading: "Candidates In Pipeline",
              subheading: "Total Placed :",
              count1: res.data?.data.in_pipeline,
              count2: 0,
              img: A6,
            },
            {
              heading: "Total Placed",
              subheading: "Total Job Post :",
              count1: res.data?.data.placed,
              count2: 0,
              img: A7,
            },
          ])
        )
      )
      .catch((err) => {
        setLoading(false);
        setKpiArr([
          {
            heading: "Total Candidates Shared",
            subheading: "Total Placed :",
            count1: 0,
            count2: 0,
            img: A1,
          },
          {
            heading: "Jobs Assigned",
            subheading: "Total Job Post :",
            count1: 0,
            count2: 0,
            img: A2,
          },
          {
            heading: "Candidates Accross Jobs",
            subheading: "Recently Added :",
            count1: 0,
            count2: 0,
            img: A1,
          },
          {
            heading: "Jobs Accepted",
            subheading: "Total Job Post :",
            count1: 0,
            count2: 0,
            img: A3,
          },
          {
            heading: "Jobs Rejected",
            subheading: "Upcoming Job Fair :",
            count1: 0,
            count2: 0,
            img: A4,
          },
          {
            heading: "Jobs Onhold",
            subheading: "Recently Added :",
            count1: 0,
            count2: 0,
            img: A5,
          },
          {
            heading: "Candidates In Pipeline",
            subheading: "Total Placed :",
            count1: 0,
            count2: 0,
            img: A6,
          },
          {
            heading: "Total Placed",
            subheading: "Total Job Post :",
            count1: 0,
            count2: 0,
            img: A7,
          },
        ]);
      });
  };

  useEffect(() => {
    FetchGraph5();
  }, [value]);
  useEffect(() => {
    FetchGraph2();
  }, [jobId]);
  useEffect(() => {
    FetchGraph4();
  }, [value1]);

  /*
  const HtmlTooltip = styled(({ className, ...props }) => (
    <InfoTooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 220,
      textAlign: "left",
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9",
    },
  }));
  */

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Muitooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9",
    },
  }));

  const InfoObj = {
    chart1:
      "The chart illustrates the job requirements given by Saksham, contrasting them with the requirements accepted by our partner and those that have been rejected.",
    chart2:
      "This pipeline illustrates the distribution of candidates across different stages, spanning from the initial pool to the post-selection phase. It includes a breakdown of candidate counts at each stage and offers insights into the reasons for any observed leakages.",
    chart3:
      "The chart illustrates the distribution of the number of openings accepted to be handled by the partner, the number of candidates provided by the partner against these openings, and the number of candidates that have been successfully verified and currently under engagement.",
    chart4:
      "This distribution shows the distribution of available opportunities that we believe are relevant to you (Requested), and the distribution of opportunities that you have accepted to fulfil (Accepted). You can use this to enhance the sourcing of candidates.",
    chart5:
      "The following graph provides a comprehensive overview of candidate backgrounds, specifically focusing on their educational qualifications, gender distribution, and age demographics. The distribution is post initial verification and cleaning by the system.",
    chart6:
      "This chart provides an overview of the total number of candidates against those engaged and subsequently placed in fulfilment of specified requirements.",
  };

  console.log(KPIObj);
  return (
    <>
      <DashboardLayout>
        <SGHeading>Dashboard</SGHeading>

        <Grid container spacing={1} sx={{ mt: 1 }}>
          {loading ? (
            <>
              {Array.from(Array(8).keys()).map((v, i) => {
                return (
                  <Grid item lg={3} sm={12} md={6} xs={12} key={i}>
                    <SBox1>
                      <SBox2>
                        <SVerticalBox>&nbsp;</SVerticalBox>

                        <SBox3>
                          <Box>
                            <Skeleton
                              variant="rounded"
                              animation="wave"
                              sx={{ height: "14px", width: "120px", m: 0.5, mb: 1.7 }}
                            />

                            <Skeleton
                              variant="rounded"
                              animation="wave"
                              sx={{ height: "20px", width: "90px", m: 0.5, mb: 1.3 }}
                            />
                          </Box>

                          <Box>
                            <Skeleton
                              variant="rounded"
                              animation="wave"
                              sx={{ height: "42px", width: "44px" }}
                            />
                          </Box>
                        </SBox3>
                      </SBox2>
                    </SBox1>
                  </Grid>
                );
              })}
            </>
          ) : (
            <>
              {kpiArr.map((v, i) => {
                return (
                  <Grid item lg={3} sm={12} md={6} xs={12} key={i}>
                    <SBox1>
                      <SBox2>
                        <SVerticalBox>&nbsp;</SVerticalBox>

                        <SBox3>
                          <Box>
                            <SKPIHeading>
                              {v.heading} <img src={info} height={"15px"} width={"15px"} />
                            </SKPIHeading>

                            <SKPICount>{v.count1}</SKPICount>

                            {/* <Box
                              sx={{
                                p: 0.65,
                                m: 0.5,
                                background: "rgba(112, 186, 191, 0.17)",
                                borderRadius: "7px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexWrap: "wrap",
                              }}
                            >
                              <SKPISubHeading1>{v.subheading}</SKPISubHeading1>

                              <SKPISubHeading2>{v.count2}</SKPISubHeading2>
                            </Box> */}
                          </Box>

                          <Box>
                            <img src={v.img} alt="" height={"42px"} width={"44px"} />
                          </Box>
                        </SBox3>
                      </SBox2>
                    </SBox1>
                  </Grid>
                );
              })}
            </>
          )}

          <Grid item lg={4} sm={12} md={6} xs={12} />
          <Grid item lg={4} sm={12} md={6} xs={12} />

          <Grid item lg={6} sm={12} md={12} xs={12}>
            <SGridBox>
              <Box
                sx={{
                  p: 1,
                  display: "flex",
                  // justifyContent: "space-between",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <SHeading>
                  {/* Requested <span style={{ color: "#ACACAC" }}>vs </span>
                 
                  Accepted <span style={{ color: "#ACACAC" }}>vs </span>
                  {
                  Declined */}
                  Job Mandates Overview
                </SHeading>
                <SoftBox>
                  {/* <InfoTooltip title={InfoObj.chart1} placement="right-start">
                    <InfoOutlinedIcon />
                  </InfoTooltip> */}
                  <HtmlTooltip title={InfoObj.chart1} placement="right-start">
                    <IconButton>
                      <InfoOutlinedIcon />
                    </IconButton>
                  </HtmlTooltip>
                </SoftBox>
              </Box>
              <SUnderlineBox />
              <ResponsiveContainer width="100%" height={350} marginTop="25px">
                <BarChart
                  width={400}
                  height={200}
                  data={data}
                  margin={{
                    top: 30,
                    right: 30,
                    left: 30,
                    bottom: 10,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" fontSize={"9px"} />
                  <YAxis fontSize={"9px"} />
                  <Tooltip itemStyle={{ fontFamily: "Montserrat", fontSize: "14px" }} />
                  <Bar dataKey="count" stackId="a" fill="#90BE6D" barSize={100} />
                </BarChart>
              </ResponsiveContainer>

              <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <SGraphSubHeading>
                  <SquareIcon fontSize="medium" sx={{ color: "#90BE6D" }} />
                  Job Mandates Given by Saksham
                </SGraphSubHeading>
              </Box>
            </SGridBox>
          </Grid>

          <Grid item lg={6} sm={12} md={12} xs={12}>
            <SGridBox>
              <Box
                sx={{
                  p: 1,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    // p: 1,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <SHeading>Placement Pipeline</SHeading>
                  <SoftBox>
                    <HtmlTooltip title={InfoObj.chart2} placement="right-start">
                      <IconButton>
                        <InfoOutlinedIcon />
                      </IconButton>
                    </HtmlTooltip>
                  </SoftBox>
                </Box>
                <Select
                  // width="200px"
                  placeholder="ALL"
                  // isClearable
                  // value={
                  //   jobName !== "" ? { label: jobName, value: jobId } : { label: "ALL", value: "" }
                  // }
                  options={roleOptions}
                  styles={stylesDD}
                  onChange={(e) => (setJobId(e.value), setJobName(e.label))}
                />
              </Box>

              <SUnderlineBox />
              <Box sx={{ width: "100%" }}>
                <Grid container>
                  <Grid item lg={4} md={4} sm={4} xs={4}>
                    <Box sx={{ mt: 5 }}>
                      {data6.map((v, i) => {
                        return (
                          <Box key={i} sx={{ height: "50px", textAlign: "right" }}>
                            {/* <Typography
                              sx={{
                                fontSize: "10px",
                                fontWeight: 500,
                                color: "#C6C6C6",
                                fontStyle: "normal",
                                fontFamily: "Inter",
                                p: 1,
                                mr: 6 - i,
                              }}
                            >
                              {v.name}
                            </Typography> */}
                            <SGSubHeading>{v.name}</SGSubHeading>
                          </Box>
                        );
                      })}
                    </Box>
                  </Grid>

                  <Grid item lg={4} md={4} sm={4} xs={4}>
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        ml: 2,
                        mr: 2,
                      }}
                    >
                      <ReactApexChart
                        options={option3.options}
                        series={Series.series}
                        type="bar"
                        height={385}
                        width={200}
                      />
                    </Box>
                  </Grid>

                  <Grid item lg={2} md={2} sm={2} xs={2}>
                    <Box sx={{ mt: 5, ml: 6 }}>
                      {option3.options.xaxis.percentage.map((v, i) => {
                        return (
                          <Box key={i} sx={{ height: "50px", textAlign: "left" }}>
                            {/* <Typography
                              sx={{
                                fontSize: "10px",
                                fontWeight: 500,
                                color: "#C6C6C6",
                                fontStyle: "normal",
                                fontFamily: "Inter",
                                p: 1,
                                ml: 6 - i,
                              }}
                            >
                              60%
                            </Typography> */}
                            <SGSubHeading>{Math.round(v)}%</SGSubHeading>
                          </Box>
                        );
                      })}
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </SGridBox>
          </Grid>

          <Grid item lg={6} sm={12} md={12} xs={12}>
            <SGridBox>
              <Box
                sx={{
                  p: 1,
                  display: "flex",
                  // justifyContent: "space-between",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <SHeading>
                  Total Requirements <span style={{ color: "#ACACAC" }}>vs </span>
                  {/* <br /> */}
                  Shared <span style={{ color: "#ACACAC" }}>vs </span>
                  {/* <br /> */}
                  Engaged
                </SHeading>
                <SoftBox>
                  <HtmlTooltip title={InfoObj.chart3} placement="right-start">
                    <IconButton>
                      <InfoOutlinedIcon />
                    </IconButton>
                  </HtmlTooltip>
                </SoftBox>
              </Box>
              <SUnderlineBox />
              <ResponsiveContainer width="100%" height={350} marginTop="25px">
                <BarChart
                  width={500}
                  height={300}
                  data={data1}
                  margin={{
                    top: 5,
                    right: 10,
                    left: 5,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" fontSize={"9px"} />
                  <YAxis fontSize={"9px"} />
                  <Tooltip
                    // itemStyle={{ fontFamily: "Montserrat", fontSize: "14px" }}
                    content={<CustomTooltip />}
                  />
                  <Bar dataKey="requested" fill="#F94144" barSize={25} />
                  <Bar dataKey="shared" fill="#90BE6D" barSize={25} />
                  <Bar dataKey="shortlisted" fill="#2D9CDB" barSize={25} />
                </BarChart>
              </ResponsiveContainer>

              <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <SGraphSubHeading>
                  <SquareIcon fontSize="medium" sx={{ color: "#F94144" }} />
                  Requirements Given
                </SGraphSubHeading>

                <SGraphSubHeading>
                  <SquareIcon fontSize="medium" sx={{ color: "#90BE6D" }} />
                  Shared
                </SGraphSubHeading>

                <SGraphSubHeading>
                  <SquareIcon fontSize="medium" sx={{ color: "#2D9CDB" }} />
                  Engaged
                </SGraphSubHeading>
              </Box>
            </SGridBox>
          </Grid>

          <Grid item lg={6} sm={12} md={12} xs={12}>
            <SGridBox>
              <SBox5>
                <Box
                  sx={{
                    // p: 1,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <SHeading>Job Role Trends</SHeading>
                  <SoftBox>
                    <HtmlTooltip title={InfoObj.chart4} placement="right-start">
                      <IconButton>
                        <InfoOutlinedIcon />
                      </IconButton>
                    </HtmlTooltip>
                  </SoftBox>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs value={value1} onChange={handleChange1}>
                      <Tab label="Requested" sx={{ ml: 0.5, mr: 0.5, fontFamily: "Montserrat" }} />
                      <Tab label="Accepted" sx={{ ml: 0.5, mr: 0.5, fontFamily: "Montserrat" }} />
                    </Tabs>
                  </Box>
                </Box>
              </SBox5>
              <SUnderlineBox />

              <Grid container>
                {/* <Grid item lg={3} md={12} sm={12} xs={12}>
                  <Box
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      p: 1,
                    }}
                  >
                    {data3.map((v, i) => {
                      return (
                        <SoftTypography fontSize={"14px"} key={i}>
                          <SquareIcon fontSize="small" sx={{ color: v.color }} />
                          {v.label}
                        </SoftTypography>
                      );
                    })}
                  </Box>
                </Grid> */}

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <div
                    style={{
                      height: "320px",
                      marginLeft: "5px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-end",
                    }}
                  >
                    <ResponsivePie
                      data={data3}
                      margin={{
                        top: 40,
                        right: 80,
                        bottom: 80,
                        left: 80,
                      }}
                      innerRadius={0.5}
                      motionConfig="gentle"
                      transitionMode="middleAngle"
                      padAngle={1}
                      cornerRadius={1}
                      activeOuterRadiusOffset={8}
                      borderWidth={1}
                      borderColor={{
                        from: "color",
                        modifiers: [["darker", 0.2]],
                      }}
                      colors={{ scheme: "set1" }}
                      enableArcLinkLabels={true}
                      //   arcLinkLabel="id"
                      arcLinkLabel={(e) => {
                        console.log("e", e);
                        return e.data.percent;
                        // return e.id + " (" + e.data.percent + ")";
                      }}
                      arcLinkLabelsSkipAngle={10}
                      arcLinkLabelsTextColor="#333333"
                      arcLinkLabelsThickness={2}
                      arcLinkLabelsDiagonalLength={9}
                      arcLinkLabelsStraightLength={15}
                      arcLinkLabelsColor={{ from: "color" }}
                      enableArcLabels={false}
                      // arcLabel={(e) => e.data.percent}
                      arcLabelsSkipAngle={10}
                      arcLabelsTextColor={{
                        from: "color",
                        modifiers: [["darker", "3"]],
                      }}
                      // tooltip={(e) => {
                      //   let { datum: t } = e;
                      //   return i.createElement(
                      //     l,
                      //     { style: { color: t.data.color } },
                      //     i.createElement(s, null, "id"),
                      //     i.createElement(d, null, t.data.id),
                      //     i.createElement(s, null, "value"),
                      //     i.createElement(d, null, t.data.value),
                      //     i.createElement(s, null, "formattedValue"),
                      //     i.createElement(d, null, t.data.formattedValue),
                      //     i.createElement(s, null, "color"),
                      //     i.createElement(d, null, t.data.color)
                      //   );
                      // }}

                      legends={[
                        {
                          anchor: "bottom",
                          direction: "column",
                          justify: false,
                          // translateX: -250,
                          // translateY: 10,
                          translateX: -250,
                          translateY: 10,
                          itemsSpacing: 5,
                          itemWidth: 60,
                          itemHeight: 20,
                          itemTextColor: "#000",
                          itemDirection: "left-to-right",
                          itemOpacity: 1,
                          symbolSize: 18,
                          symbolShape: "square",
                          effects: [
                            {
                              on: "hover",
                              style: {
                                itemTextColor: "#000",
                              },
                            },
                          ],
                        },
                      ]}
                    />
                  </div>
                </Grid>
              </Grid>
            </SGridBox>
          </Grid>

          <Grid item lg={6} sm={12} md={12} xs={12}>
            <SGridBox>
              <SBox5>
                <Box
                  sx={{
                    // p: 1,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <SHeading1>Candidate Demographic Overview</SHeading1>
                  <SoftBox>
                    {/* <InfoTooltip title={InfoObj.chart5} placement="right-start">
                      <InfoOutlinedIcon />
                    </InfoTooltip> */}
                    <HtmlTooltip title={InfoObj.chart5} placement="right-start">
                      <IconButton sx={{ m: 0, p: 0 }}>
                        <InfoOutlinedIcon />
                      </IconButton>
                    </HtmlTooltip>
                  </SoftBox>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs value={value} onChange={handleChange}>
                      <Tab
                        label="Qualification"
                        sx={{ ml: 0.5, mr: 0.5, fontFamily: "Montserrat" }}
                      />
                      <Tab label="Gender" sx={{ ml: 0.5, mr: 0.5, fontFamily: "Montserrat" }} />
                      <Tab
                        label="Age"
                        // onClick={(e) => console.log("roletype:", e.value)}
                        sx={{ ml: 0.5, mr: 0.5, fontFamily: "Montserrat" }}
                      />
                      {/* <Tab label="Experience" sx={{ ml: 0.5, mr: 0.5, fontFamily: "Montserrat" }} /> */}
                    </Tabs>
                  </Box>
                </Box>
              </SBox5>
              <SUnderlineBox />
              {/*
              <Box
                sx={{
                  // width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  // height:"110px",
                  flexWrap: "wrap",
                  // justifyContent: "left",
                  // display:"flex",
                  overflow: "scroll",

                  // mt: 3,
                  mb: -12,
                }}
              >
                {data4?.map((v, i) => {
                  return (
                    <SGTitles key={i}>
                      <SquareIcon fontSize="medium" sx={{ color: v.color }} />
                      {v.role}
                    </SGTitles>
                  );
                })}
              </Box>
              */}

              <Grid container>
                {/* <Grid item lg={3} md={12} sm={12} xs={12}>
                  <Box
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      p: 1,
                    }}
                  >
                    {data4.map((v, i) => {
                      return (
                        <SoftTypography fontSize={"14px"} key={i}>
                          <SquareIcon fontSize="small" sx={{ color: v.color }} />
                          {v.label}
                        </SoftTypography>
                      );
                    })}
                  </Box>
                </Grid> */}

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <div
                    style={{
                      height: "320px",
                      marginLeft: "5px",
                      // display: "flex",
                      // justifyContent: "center",
                      // alignItems: "center",
                    }}
                  >
                    <ResponsivePie
                      data={data4}
                      margin={{
                        top: 40,
                        right: 80,
                        bottom: 80,
                        left: 80,
                      }}
                      innerRadius={0.5}
                      motionConfig="gentle"
                      transitionMode="middleAngle"
                      padAngle={1}
                      cornerRadius={1}
                      activeOuterRadiusOffset={8}
                      borderWidth={1}
                      borderColor={{
                        from: "color",
                        modifiers: [["darker", 0.2]],
                      }}
                      colors={{ scheme: "set1" }}
                      enableArcLinkLabels={true}
                      //   arcLinkLabel="id"
                      arcLinkLabel={(e) => {
                        console.log("e", e);
                        return e.data.percent;
                        // return e.id + " (" + e.data.percent + ")";
                      }}
                      arcLinkLabelsSkipAngle={10}
                      arcLinkLabelsTextColor="#333333"
                      arcLinkLabelsThickness={2}
                      arcLinkLabelsDiagonalLength={9}
                      arcLinkLabelsStraightLength={15}
                      arcLinkLabelsColor={{ from: "color" }}
                      enableArcLabels={false}
                      // arcLabel={(e) => e.data.percent}
                      arcLabelsSkipAngle={10}
                      arcLabelsTextColor={{
                        from: "color",
                        modifiers: [["darker", "3"]],
                      }}
                      legends={[
                        {
                          anchor: "bottom",
                          direction: "column",
                          justify: false,
                          // translateX: -250,
                          // translateY: 10,
                          translateX: -250,
                          translateY: 10,
                          itemsSpacing: 5,
                          itemWidth: 60,
                          itemHeight: 20,
                          itemTextColor: "#000",
                          itemDirection: "left-to-right",
                          itemOpacity: 1,
                          symbolSize: 18,
                          symbolShape: "square",
                          effects: [
                            {
                              on: "hover",
                              style: {
                                itemTextColor: "#000",
                              },
                            },
                          ],
                        },
                      ]}
                      // margin={{
                      //   top: 50,
                      //   right: 50,
                      //   bottom: 50,
                      //   left: 50,
                      // }}
                      // innerRadius={0.25}
                      // motionConfig="gentle"
                      // transitionMode="middleAngle"
                      // padAngle={1}
                      // cornerRadius={1}
                      // activeOuterRadiusOffset={8}
                      // borderWidth={1}
                      // borderColor={{
                      //   from: "color",
                      //   modifiers: [["darker", 0.2]],
                      // }}
                      // colors={{ scheme: "set1" }}
                      // enableArcLinkLabels={true}
                      // //   arcLinkLabel="id"
                      // arcLinkLabel={(e) => {
                      //   return e.data.percent;
                      //   // return e.id + " (" + e.data.percent + ")";
                      // }}
                      // arcLinkLabelsSkipAngle={10}
                      // arcLinkLabelsTextColor="#333333"
                      // arcLinkLabelsThickness={2}
                      // arcLinkLabelsDiagonalLength={9}
                      // arcLinkLabelsStraightLength={15}
                      // arcLinkLabelsColor={{ from: "color" }}
                      // enableArcLabels={false}
                      // // arcLabel={(e) => e.data.percent}
                      // arcLabelsSkipAngle={10}
                      // arcLabelsTextColor={{
                      //   from: "color",
                      //   modifiers: [["darker", "3"]],
                      // }}
                      // legends={[
                      //   {
                      //     anchor: "bottom",
                      //     direction: "column",
                      //     justify: false,
                      //     // translateX: -250,
                      //     // translateY: 10,
                      //     translateX: -250,
                      //     translateY: 10,
                      //     itemsSpacing: 5,
                      //     itemWidth: 60,
                      //     itemHeight: 20,
                      //     itemTextColor: "#000",
                      //     itemDirection: "left-to-right",
                      //     itemOpacity: 1,
                      //     symbolSize: 18,
                      //     symbolShape: "square",
                      //     effects: [
                      //       {
                      //         on: "hover",
                      //         style: {
                      //           itemTextColor: "#000",
                      //         },
                      //       },
                      //     ],
                      //   },
                      // ]}
                    />
                  </div>
                </Grid>
              </Grid>

              {/*
              <ResponsiveContainer width="100%" height="100%">
                <PieChart width={300} height={300}>
                  <Pie
                    data={data4}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    label={renderCustomizedLabel}
                    outerRadius={100}
                    fill="#8884d8"
                    dataKey="value"
                  >
                    {data4?.map((entry, index) => (
                      // <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                  <Tooltip itemStyle={{ fontFamily: "Montserrat", fontSize: "14px" }} />
                </PieChart>
              </ResponsiveContainer>
              */}
            </SGridBox>
          </Grid>

          <Grid item lg={6} sm={12} md={12} xs={12}>
            <SGridBox>
              <SBox5>
                <Box
                  sx={{
                    // p: 1,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <SHeading>
                    Total Candidates <span style={{ color: "#ACACAC" }}>vs </span>
                    {/* <br /> */}
                    Engaged <span style={{ color: "#ACACAC" }}>vs </span>
                    {/* <br /> */}
                    Selected
                  </SHeading>
                  <SoftBox>
                    <HtmlTooltip title={InfoObj.chart6} placement="bottom">
                      <IconButton>
                        <InfoOutlinedIcon />
                      </IconButton>
                    </HtmlTooltip>
                  </SoftBox>
                </Box>
              </SBox5>

              <SUnderlineBox />
              <ResponsiveContainer width="100%" height={350} marginTop="25px">
                <BarChart
                  width={400}
                  height={200}
                  data={data5}
                  margin={{
                    top: 30,
                    right: 30,
                    left: 30,
                    bottom: 10,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" fontSize={"9px"} />
                  <YAxis fontSize={"9px"} />
                  <Tooltip itemStyle={{ fontFamily: "Montserrat", fontSize: "14px" }} />
                  <Bar dataKey="count" stackId="a" fill="#000" barSize={70} />
                </BarChart>
              </ResponsiveContainer>

              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <SGraphSubHeading>
                  <SquareIcon fontSize="medium" sx={{ color: "#F94144" }} />
                  Total Candidates
                </SGraphSubHeading>

                <SGraphSubHeading>
                  <SquareIcon fontSize="medium" sx={{ color: "#2D9CDB" }} />
                  Engaged Candidates
                </SGraphSubHeading>

                <SGraphSubHeading>
                  <SquareIcon fontSize="medium" sx={{ color: "#90BE6D" }} />
                  Placed Candidates
                </SGraphSubHeading>
              </Box>
            </SGridBox>
          </Grid>
        </Grid>

        {/*
        <SoftBox>
          <SoftTypography mb={2} fontWeight="medium" fontSize="24px">
            Overview
          </SoftTypography>
        </SoftBox>
        */}
      </DashboardLayout>
    </>
  );
};

export default SuperAdminOverview;
CustomTooltip.propTypes = {
  payload: PropTypes.string,
  label: PropTypes.string,
  active: PropTypes.bool,
};
